import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Button, DialogContentText, DialogActions, } from '@mui/material';
import { Spinner, Form } from 'reactstrap';
import { toast } from 'react-toastify';
import { api } from '../../services/api';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { Add, DeleteOutline, Warning } from '@mui/icons-material';

const ClickMacroModal = ({ open, onClose, loading }) => {
  const param = useParams();
  const [showForm, setShowForm] = useState(false);
  const [credentials, setCredentials] = useState([]);
  const [selectedCredential, setSelectedCredential] = useState("");
  const [selectedCredentialDetails, setSelectedCredentialDetails] = useState(null);
  const [loadingCredentials, setLoadingCredentials] = useState(false);
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [confirmDelete, setConfirmDelete] = useState(false);

  const [tipoPago, setTipoPago] = useState("AMBOS");
  const [formData, setFormData] = useState({
    nombre: '',
    guid: '',
    frase: ''
  });

  useEffect(() => {
    if (open) {
      loadCredentials();
    }
  }, [open]);

  useEffect(() => {
    if (selectedCredential) {
      loadCredentialDetails();
    } else {
      setSelectedCredentialDetails(null);
    }
  }, [selectedCredential]);

  const loadCredentials = async () => {
    setLoadingCredentials(true);
    try {
      const response = await api.clickmacro.getCredential();
      if (response.status === "success") {
        setCredentials(response.data);
      }
    } catch (error) {
      toast.error("Error al cargar las credenciales");
    } finally {
      setLoadingCredentials(false);
    }
  };

  const loadCredentialDetails = async () => {
    if (!selectedCredential) return;

    setLoadingDetail(true);
    try {
      const response = await api.clickmacro.getCredentialById(selectedCredential);
      if (response.status === "success") {
        setSelectedCredentialDetails(response.data);
      }
    } catch (error) {
      toast.error("Error al cargar los detalles de la credencial");
      setSelectedCredentialDetails(null);
    } finally {
      setLoadingDetail(false);
    }
  };

  const openConfirm = () => {
    setConfirmDelete(true);
  }

  const closeConfirm = () => {
    setConfirmDelete(false);
  }

  const handleDeleteCredential = async () => {
    setLoadingDelete(true);
    try {
      const response = await api.clickmacro.deleteCredential(selectedCredential);
      if (response.status === "success") {
        toast.success("Credencial eliminada exitosamente");
        setSelectedCredential('');
        setSelectedCredentialDetails(null);
        loadCredentials();
      }
    } catch (error) {
      toast.error(error.message || "Error al eliminar la credencial");
    } finally {
      setLoadingDelete(false);
      closeConfirm();
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      let response;

      if (showForm) {
        response = await api.clickmacro.createCredential(formData);
        if (response.status === "success") {
          const assignResponse = await api.clickmacro.assignCredential({
            idevento: parseInt(param?.id),
            idcredencial: response.data.id,
            tipo_pago: tipoPago || "AMBOS"
          });

          if (assignResponse.status === "success") {
            toast.success("Credencial creada y asignada exitosamente");
            onClose();
            window.location.reload();
          }
        }
      } else {

        response = await api.clickmacro.assignCredential({
          idevento: parseInt(param?.id),
          idcredencial: parseInt(selectedCredential),
          tipo_pago: tipoPago || "AMBOS"
        });

        if (response.status === "success") {
          toast.success("Credencial asignada exitosamente");
          onClose();
          window.location.reload();
        }
      }
    } catch (error) {
      toast.error(error.message || "Error al procesar la solicitud");
    }
  };

  const handleClose = () => {
    setShowForm(false);
    setSelectedCredential('');
    setTipoPago("AMBOS");
    setFormData({
      nombre: '',
      guid: '',
      frase: ''
    });
    onClose();
  };

  const renderCredentialDetails = () => {
    if (loadingDetail) {
      return (
        <div className="text-center my-3">
          <Spinner color="primary" />
        </div>
      );
    }

    if (!selectedCredentialDetails) return null;

    return (
      <div className="my-3">
        <div style={{ backgroundColor: "#FAFAFB", borderRadius: "8px", padding: "16px", border: "1px solid #E6E6FF" }}>
          <div className='d-flex flex-column flex-sm-row justify-content-between align-items-sm-center mb-2'>
            <p className='mb-2 mb-sm-0' style={{ color: "#0B0060", fontWeight: "500", fontSize: "18px" }}>Información de la credencial</p>
            <button
              type="button"
              onClick={openConfirm}
              disabled={loadingDelete}
              style={{ fontSize: "14px !important", padding: "0", fontFamily: "Bricolage Grotesque", color: "red" }}
              title='Eliminar'
            >
              {loadingDelete ? (
                <Spinner size="sm" />
              ) : (
                <>
                  <DeleteOutline fontSize="small" />
                </>
              )}
            </button>
          </div>
          <div className='d-flex flex-column gap-2 '>
            <div>
              <p className='mb-0' style={{ fontWeight: "600" }}>Nombre: </p>
              <span>{selectedCredentialDetails?.nombre}</span>
            </div>
            <div>
              <p className='mb-0' style={{ fontWeight: "600" }}>GUID: </p>
              <span>{selectedCredentialDetails?.guid}</span>
            </div>
            <div>
              <p className='mb-0' style={{ fontWeight: "600" }}>Frase: </p>
              <span>{selectedCredentialDetails?.frase ?
                `****${selectedCredentialDetails.frase.substring(selectedCredentialDetails.frase.length - 5)}`
                : 'N/A'}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ padding: "16px 24px 10px !important", color: "#5656FF", fontSize: "20px", fontWeight: "600" }}>
          {showForm ? "Nueva credencial Click Macro" : "Seleccionar credencial Click Macro"}
        </DialogTitle>
        <DialogContent>
          {!showForm ? (
            <div className="mt-3">
              {loadingCredentials ? (
                <div className="text-center">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <select
                    className="form-select mb-2"
                    value={selectedCredential}
                    onChange={(e) => setSelectedCredential(e.target.value)}
                  >
                    <option value="">Seleccionar credencial...</option>
                    {credentials.map(cred => (
                      <option key={cred.id} value={cred.id}>
                        {cred.nombre}
                      </option>
                    ))}
                  </select>

                  {selectedCredential && renderCredentialDetails()}

                  <div className="mb-3">
                    <label className="form-label">Métodos de pago disponibles</label>
                    <select
                      className="form-select"
                      value={tipoPago}
                      onChange={(e) => setTipoPago(e.target.value)}
                    >
                      <option value="AMBOS">QR + Link de pago</option>
                      <option value="QR">Solo código QR</option>
                      <option value="LINK">Solo link de pago</option>
                    </select>
                  </div>

                  <div className={`d-flex ${window.innerWidth <= 576 ? 'flex-column' : 'justify-content-between'} mt-4`}
                    style={{ gap: window.innerWidth <= 576 ? '10px' : '0' }}>
                    <button
                      type='button'
                      style={{
                        border: "1px solid #5656FF",
                        color: "#5656FF",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                        width: window.innerWidth <= 576 ? "100%" : "auto"
                      }}
                      onClick={() => setShowForm(true)}
                    >
                      <Add fontSize="small" style={{ marginRight: "4px" }} />
                      Crear nueva credencial
                    </button>
                    <button
                      style={{
                        backgroundColor: "#5656FF",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: window.innerWidth <= 576 ? "13px" : "14px",
                        width: window.innerWidth <= 576 ? "100%" : "auto"
                      }}
                      disabled={!selectedCredential || loading}
                      onClick={handleSave}
                    >
                      {loading ? <Spinner size="sm" /> : 'Asignar credencial'}
                    </button>
                  </div>
                </>
              )}
            </div>
          ) : (
            <Form onSubmit={handleSave} className="mt-3">
              <div className="mb-3">
                <label className="form-label">Nombre de la credencial</label>
                <input
                  type="text"
                  className="form-control"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">GUID</label>
                <input
                  type="text"
                  className="form-control"
                  name="guid"
                  value={formData.guid}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Frase</label>
                <input
                  type="password"
                  className="form-control"
                  name="frase"
                  value={formData.frase}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Métodos de pago disponibles</label>
                <select
                  className="form-select"
                  value={tipoPago}
                  onChange={(e) => setTipoPago(e.target.value)}
                >
                  <option value="AMBOS">QR + Link de pago</option>
                  <option value="QR">Solo código QR</option>
                  <option value="LINK">Solo link de pago</option>
                </select>
              </div>
              <div className="d-flex justify-content-between mt-4">
                <Button
                  variant="outlined"
                  sx={{ borderColor: "#5656FF", color: "#5656FF" }}
                  onClick={() => setShowForm(false)}
                >
                  Volver
                </Button>
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ backgroundColor: "#5656FF", color: "white" }}
                  disabled={loading}
                >
                  {loading ? <Spinner size="sm" /> : 'Guardar credencial'}
                </Button>
              </div>
            </Form>
          )}
        </DialogContent>
      </Dialog>
      <Dialog
        open={confirmDelete}
        onClose={closeConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title" sx={{ display: "flex", alignItems: "center" }}>
          <Warning color="warning" sx={{ mr: 1 }} />
          Confirmar eliminación
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            ¿Estás seguro de que deseas eliminar esta credencial? Esta acción no se puede deshacer.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={closeConfirm}
            type='button'
            style={{
              backgroundColor: "transparent",
              color: "#5656FF",
              border: "1px solid #5656FF",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            Cancelar
          </button>
          <button
            onClick={handleDeleteCredential}
            autoFocus
            disabled={loadingDelete}
            type='button'
            style={{
              backgroundColor: "red",
              color: "white",
              border: "none",
              padding: "5px 10px",
              borderRadius: "4px",
              cursor: "pointer"
            }}
          >
            {loadingDelete ? (
              <Spinner size="sm" />
            ) : (
              <>
                <DeleteOutline fontSize="small" style={{ marginRight: "4px" }} />
                Eliminar
              </>
            )}
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ClickMacroModal;